// import * as icons from "@material-ui/icons";
import { CircularProgress } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/Table';
import { fetchPlaceStatsRequest } from '../../../store/actions/stats';
import { IPlaceStatsRow, IStatsState } from '../../../store/types/stats';

class PlaceStats extends React.Component<any, any> {
  public componentDidMount() {
    this.props.fetchPlaceStats();
  }

  public render() {
    const rows = this.props.rows as IPlaceStatsRow[];

    if (this.props.loading) {
      return <CircularProgress />;
    }

    if (!rows.length) {
      return <p>No data!</p>;
    }

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Place</TableCell>
            <TableCell title="At least 1 accepted" numeric={true}>
              % Successful Jobs
            </TableCell>
            <TableCell numeric={true}>Number of Applicants per Job</TableCell>
            <TableCell numeric={true}>Number of Reactions per Job</TableCell>
            <TableCell title="Number of candidates here / number of jobs" numeric={true}>
              Number of Candidates per Job
            </TableCell>
            <TableCell numeric={true}>Total Number of Jobs</TableCell>
            <TableCell numeric={true}>Total Number of Candidates</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((r, i) => {
            return (
              <TableRow key={i} hover={true}>
                <TableCell>{r.city}</TableCell>
                <TableCell numeric={true}>{r.successful_jobs}</TableCell>
                <TableCell numeric={true}>{r.interested_applications_average}</TableCell>
                <TableCell numeric={true}>{r.applications_average}</TableCell>
                <TableCell numeric={true}>{r.candidates_in_the_area_per_job}</TableCell>
                <TableCell numeric={true}>{r.job_total}</TableCell>
                <TableCell numeric={true}>{r.users_in_area}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  }
}

const mapStateToProps = (state: { stats: IStatsState }) => {
  return {
    rows: state.stats.places || [],
    loading: state.stats.loading,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchPlaceStats: () => dispatch(fetchPlaceStatsRequest()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PlaceStats);



// WEBPACK FOOTER //
// ./src/screens/Dashboard/PlaceStats/PlaceStats.tsx